
const tests = [
     {
        target: 1,
        options: [2,3,4,5]
    },
    {
        target: 2,
        options: [1,3,4,5,6]
    },
    {
        target: 3,
        options: [1,2,4,5,6,7]
    },
    {
        target: 4,
        options: [2,3,5,6,7,8],
    },
    {
        target: 5,
        options: [2,3,4,6,7,8]
    },
    {
        target: 6,
        options: [3,4,5,7,8,9]
    },
    {
        target:  7,
        options: [4,5,6,8,9,10],
    },
    {
        target: 8,
        options: [4,5,6,7,9,10],
    },
    {
        target:  9,
        options: [4,5,6,7,8,10]
    },
    {
        target: 10,
        options: [5,6,7,8,9]
    }, 
    {
        target:  11,
        options: [12,13,14,15]
    },
    {
        target:  12,
        options: [11,13,14,15,16]
    },
    {
        target:  13,
        options: [11,12,14,15,16,17]
    },
    {
        target:  14,
        options: [12,13,15,16,17,18],
    },
    {
        target:  15,
        options: [12,13,14,16,17,18]
    },
    {
        target:  16,
        options: [13,14,15,17,18,19]
    },
    {
        target:  17,
        options: [14,15,16,18,19,20],
    },
    {
        target:  18,
        options: [14,15,16,17,19,20],
    },
    {
        target:  19,
        options: [14,15,16,17,18,20]
    },
    {
        target:  20,
        options: [15,16,17,18,19]
    }, 
    
    
]

export default tests;